document.addEventListener('DOMContentLoaded', function () {
    const feedbackFile = document.getElementById("feedback_file"), fileLabel = document.querySelector(".file-label")

    feedbackFile.addEventListener("change", function () {
        if (feedbackFile.files.length > 0) {
            fileLabel.innerText = declOfNum(feedbackFile.files.length, ['Загружен ', 'Загружено ', 'Загружено ']) + feedbackFile.files.length.toString() + declOfNum(feedbackFile.files.length, [' файл', ' файла', ' файлов'])
        } else {
            fileLabel.innerText = "Загрузить файлы"
        }
    })
})

function declOfNum(number, titles) {
    let cases = [2, 0, 1, 1, 1, 2];

    return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
}